import { render, staticRenderFns } from "./EntityManagementPanel.vue?vue&type=template&id=65d710ae&scoped=true&"
import script from "./EntityManagementPanel.vue?vue&type=script&lang=js&"
export * from "./EntityManagementPanel.vue?vue&type=script&lang=js&"
import style0 from "./EntityManagementPanel.vue?vue&type=style&index=0&id=65d710ae&prod&lang=css&"
import style1 from "./EntityManagementPanel.vue?vue&type=style&index=1&id=65d710ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d710ae",
  null
  
)

export default component.exports